import { h } from 'preact';

const hiddenStyles = {
    width: 0,
    height: 0,
    overflow: 'hidden'
};

/* This component should be used by Annotations that do not render any visible elements */
/* It provides a repeatable method to assist with debugging these types of annotations */
export const InvisibleAnnotation = attrs => <div style={ hiddenStyles } { ...attrs }></div>;